module.exports = __webpack_public_path__ + "assets/cameraCancel@3x.d98646cc8ad5af1aabfd88542e270677.png";